import { FaCircleArrowRight } from "react-icons/fa6"
import Layout from "../../components/global/layout"
import Sidebar from "../../components/global/sidebar"
import Cards from "../Cards"

const CardListing = () => {
    return (
        <>
            <Layout>
                <div className="section-listinngs  px-4 lg:px-16 pt-6 lg:pt-24">
                    <Cards />
                </div>
            </Layout>
        </>
    )
}

export default CardListing